module.exports = __webpack_public_path__ + "img/ax_trophy.999d80b5.png";